module.exports = __webpack_public_path__ + "static/media/pass-icon.6cd21170.svg";